import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { OFFICES_GET_OFFICES, PENDING, FULFILLED, REJECTED } from '../../globals';


export function getOfficesRequest(){
  return {
    type: `${OFFICES_GET_OFFICES}_${PENDING}`,
    payload: {
      refresh: true,
    }
  };
}

export function getOfficesSuccess(response){
  return {
    type: `${OFFICES_GET_OFFICES}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getOfficesFailure(response){
  return {
    type: `${OFFICES_GET_OFFICES}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}


export const getOffices = () => ({
  [CALL_API]: {
    actions: [getOfficesRequest, getOfficesSuccess, getOfficesFailure],
    url: `${API_URL}/web/stores`,
  },
});
